import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState: Array<string> = [];

interface VenuesResponse {
	venues: Array<string>;
}

interface VenueQuery {
	cityName: string;
}

export const { thunk: fetchVenues, slice: eventVenuesSlice } = getThunkAndSlice<VenueQuery, VenuesResponse, Array<string>>({
	initialState,
	path: (params) => `/api/events/filter/venues/${encodeURIComponent(params.cityName)}`,
	onAfterRequest: async (data: VenuesResponse | Array<string>) => {
		if (Array.isArray(data)) return data;
		return data.venues ?? [];
	},
});

export default eventVenuesSlice.reducer;
